export default __webpack_public_path__ + "static/media/cloudbed.08defebe.png";